import { Link, useNavigate, useLocation } from "react-router-dom";
import { Sun, Moon, ShieldCheck, BookOpen } from "lucide-react";
import { useTheme } from "../lib/theme";
import { HOME } from "../constants/testIds";

export const Header = ({ minimal = false }) => {
  const [theme, setTheme] = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const onBuyingAdvice = location.pathname.startsWith("/buying-advice");
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/70 border-b border-border">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-5 py-2.5">
        <Link
          to="/"
          data-testid={HOME.logo}
          aria-label="Should I Buy It? — Home"
          className="flex items-center group"
        >
          <img
            src="/brand/logo.png"
            alt="Should I Buy It?"
            width="180"
            height="180"
            className="h-14 sm:h-16 w-auto select-none transition group-hover:opacity-90"
            draggable="false"
          />
        </Link>

        <div className="flex items-center gap-2">
          {!minimal && (
            <Link
              to="/buying-advice"
              data-testid="nav-buying-advice"
              className={`hidden sm:inline-flex items-center gap-1.5 text-sm font-medium px-3 py-2 rounded-lg transition ${
                onBuyingAdvice
                  ? "bg-secondary text-foreground"
                  : "text-muted-foreground hover:text-foreground hover:bg-secondary"
              }`}
            >
              <BookOpen className="w-3.5 h-3.5" />
              Buying Advice
            </Link>
          )}
          {!minimal && (
            <button
              onClick={() => navigate("/admin")}
              data-testid={HOME.adminLink}
              className="hidden sm:flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition px-3 py-2 rounded-lg hover:bg-secondary"
            >
              <ShieldCheck className="w-3.5 h-3.5" />
              Admin
            </button>
          )}
          <button
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            data-testid={HOME.themeToggle}
            aria-label="Toggle theme"
            className="w-9 h-9 rounded-lg border border-border hover:bg-secondary flex items-center justify-center transition"
          >
            {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
